import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import Section from "@/components/Section";
import masterclassImage from "@/assets/ai-masterclass-visual.png";

const AIMasterclass = () => {
  const { t } = useTranslation();

  return (
    <Section
      title={t("aiMasterclass.title")}
    >
      <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
        <div className="space-y-6">
          <div className="text-muted-foreground text-lg leading-relaxed space-y-4">
            <p>{t("aiMasterclass.p1")}</p>
            <p>{t("aiMasterclass.p2")}</p>
            <p>{t("aiMasterclass.p3")}</p>
          </div>

          <div className="flex flex-wrap gap-4 mt-2">
            <Button variant="secondary" size="lg" asChild>
              <a
                href="https://www.utbildning.se/kurser/ai-for-sverige/ai-for-ledare-masterclass-offentlig-sektor-2117933"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("aiMasterclass.readMore")}
              </a>
            </Button>
          </div>
        </div>

        <div className="relative">
          <div className="absolute -inset-2 bg-gradient-brand opacity-20 blur-2xl rounded-2xl" aria-hidden />
          <div className="relative rounded-2xl overflow-hidden aspect-square border border-border/60">
            <img
              src={masterclassImage}
              alt={t("aiMasterclass.imageAlt")}
              className="w-full h-full object-cover"
              loading="lazy"
              width="600"
              height="600"
            />
          </div>
        </div>
      </div>
    </Section>
  );
};

export default AIMasterclass;
